import { attr, belongsTo } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

class SellerLatestReportStat extends ShModel {
  @attr('number') planning;
  @attr('number') active;
  @attr('number') finalSteps;
  @attr('number') projectsCompletedYtd;
  @attr('number') projectsCompleted;

  @belongsTo('user', { async: false }) user;

  get inProgress() {
    return this.planning + this.active + this.finalSteps;
  }
}

export default SellerLatestReportStat;
